/**
 * 積替運搬からの受注登録 否決通知
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/pickups/registrations`
const orders_accepts_pickup_registration_rejection = {
  namespaced: true,
  actions: {
    /**
     * 否決通知登録
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}/rejections`
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  }
}
export default orders_accepts_pickup_registration_rejection
